<template>
    <div class="flex-col main">
        <div class="flex-row title-info" v-if="showFilter">
            <span>{{ totalCount }}条关系</span>
            <div>
                <van-dropdown-menu>
                    <van-dropdown-item v-model="sortValue" :options="sortOption" @change="sortList" />
                </van-dropdown-menu>
            </div>
        </div>
        <div class="list-content">
            <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
            <van-list v-if="showFilter" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad(true)">
                <relation-item v-for="item in itemList" v-bind:key="item.id" :data="item" :show-chk="isEdit" :is-collect="isCollect" @cancel="cancelMark"></relation-item>
            </van-list>
            <van-list v-if="!showFilter" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad(true)">
                <relation-item v-for="item in itemList" v-bind:key="item.historyId" :data="item" :show-chk="isEdit" :is-collect="isCollect" @cancel="cancelMark"></relation-item>
            </van-list>

            <!-- </van-pull-refresh> -->
        </div>
    </div>
</template>

<script>
import webService from "@network/webService";
import RelationItem from "@components/content/relation/RelationItem.vue";
import _ from "lodash";
import common from "@common/common";
import commonStyle from "@/styles/common.scss";
import userInfo from "@common/loginInfo";
import { ref } from "vue";
export default {
    name: "RelationshipList",
    components: {
        RelationItem,
    },
    data() {
        return {
            itemList: [],
            loading: false,
            finished: false,
            refreshing: false,
            totalCount: 0,
            currentPage: 0,
            sortValue: "time",
            editString: "操作",
            isCollect: 1,
            showFilter: false,
            sortOption: [
                {
                    text: "按时间排序",
                    value: "time",
                },
                {
                    text: "按关系深度降序",
                    value: "deep",
                },
            ],
        };
    },
    props: {
        pageType: {
            type: Number,
            default: 0,
        },
        isEdit: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        // console.log("relation mounted");
        this.showFilter =
            this.pageType != common.searchTypeEnum.relationHistory;
        this.isCollect =
            this.pageType == common.searchTypeEnum.relationCollect ? 1 : 0;
    },
    activated() {
        // console.log("relation activated");
    },
    methods: {
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.currentPage = 0;
            this.itemList = [];
            this.onLoad(false);
        },
        onLoad(isAdd) {
            this.editString = "操作";
            this.requestPageData(isAdd);
        },
        requestPageData(isAdd) {
            var param = {
                PageSize: 10,
                Page: this.currentPage,
                UserId: this.userId,
            };
            let _this = this;
            // debugger;
            if (this.pageType == common.searchTypeEnum.relationCollect) {
                webService.getMyFavoriteRelationships(param).then((res) => {
                    // console.log(res.data);
                    common.procssData_collect_relation(_this, res.data);

                    _this.totalCount = _this.itemList.length;
                });
            } else if (this.pageType == common.searchTypeEnum.relationHistory) {
                webService.getHistoryRelationships(param).then((res) => {
                    console.log(res.data);
                    common.procssData_myRelationship(this, res.data, true);
                    this.totalCount = this.itemList.length;
                });
            } else {
                webService.getMyRelationships(param).then((res) => {
                    common.procssData_myRelationship(this, res.data, isAdd);
                    this.totalCount = this.itemList.length;
                });
            }
        },
        sortList(value) {
            this.sortValue = value;
            if (this.itemList.length > 0) {
                switch (this.sortValue) {
                    case "time":
                        this.itemList = _.orderBy(
                            this.itemList,
                            ["createTime"],
                            ["desc"]
                        );
                        break;
                    case "deep":
                        this.itemList = _.orderBy(
                            this.itemList,
                            ["relationDeepthId"],
                            ["asc"]
                        );
                        break;
                    default:
                }
            }
        },
        goBack() {
            this.$router.push({
                path: "/home/userInfo",
            });
        },
        selectAll() {
            this.itemList.forEach((element) => {
                element.checked = true;
            });
        },
        cancelSelected() {
            this.itemList.forEach((element) => {
                element.checked = false;
            });
        },
        deleteItem() {
            common.batchDeleteMarked_Relation(this);
        },
        cancelMark(id) {
            common.cancelMark_relation(this, id);
        },
    },
};
</script>


<style lang="scss" scoped>
.main {
    height: 100%;
    border-top: 1px solid #dedede;
}
.list-content {
    height: 100%;
    overflow: auto;
}
.top-bar {
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
}
.title-info {
    span {
        font-size: 0.75rem;
        color: #464646;
        line-height: 1.125rem;
    }
    align-items: center;
    justify-content: space-between;
    padding: 0.375rem 1rem 0 1rem;

    /deep/ .van-dropdown-menu__bar {
        box-shadow: none;
    }
    /deep/ .van-dropdown-menu__title {
        font-size: 0.875rem;
    }
}
.title-lable {
    padding: 0 1rem;
    font-size: x-large;
}
// /deep/ .van-action-sheet__content {
//   display: flex;
//   flex-direction: row;
// }
</style>


// WEBPACK FOOTER //
// src/components/content/relation/RelationshipList.vue